import { Component } from '@angular/core';
import { ProductDataSource } from '../../../Model/dataProcess/productDataSource';
import { DataSourcesService } from '../../../Services/DataProcess/datasources.service';
import { LoginService } from '../../../Services/login.service';
import { TranslateService } from '@ngx-translate/core';
import { SystemService } from '../../../Services/system.service';
import { CatalogService } from '../../../Services/CatalogManagement/catalog.service';
import { DataSourceMapping } from '../../../Model/Catalog/DataSourceMapping';
import { custom } from 'devextreme/ui/dialog';
import { ViewService } from '../../../Services/view.service';
import { CountryService } from '@nextpim/shared';
import { firstValueFrom } from 'rxjs';
import { Address } from '../../../Model/Catalog/Address';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';

@Component({
    selector: 'catalog-data-source-mapping',
    templateUrl: './catalog-data-source-mapping.component.html',
    standalone: false
})
export class CatalogDataSourceMappingComponent {
  customerProductDataSources: ProductDataSource[] = [];
  customerProductDataSourcesPaged: DataSource;
  catalogManufaturerNames: DataSourceMapping[] = [];
  test: boolean = false;
  newAddedDatasource: ProductDataSource;
  countryCodes: { code: string; name: string; label: string }[] = [];
  popupVisible: boolean = false;
  isLoading = true;
  dropDownCfg = {
    toolbarItems: [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          icon: 'plus',
          stylingMode: 'outlined',
          hint: 'Datenquelle hinzufügen',
          onClick: () => this.addNewSource()
        }
      }
    ]
  };

  constructor(
    public dataSourcesService: DataSourcesService,
    public loginService: LoginService,
    public translate: TranslateService,
    public systemService: SystemService,
    public catalogService: CatalogService,
    private countryService: CountryService
  ) {
    this.changeDataSource = this.changeDataSource.bind(this);
  }

  async ngOnInit() {
    try {
      this.isLoading = true;

      const [dataSources, manufacturerNames, countries] = await Promise.all([
        this.dataSourcesService.getAll(this.loginService.currentCustomer.id),
        this.dataSourcesService.getAllCatalogManufacturerNames(
          this.catalogService.selectedCatalogId,
          this.loginService.currentCustomer.id
        ),
        firstValueFrom(this.countryService.getCountries())
      ]);

      this.customerProductDataSources = dataSources;
      this.refreshPagedDataSources();

      this.catalogManufaturerNames = manufacturerNames.map((m) => {
        const id = this.getInitialSourceId(m.manufacturerName);
        return { manufacturerName: m.manufacturerName, originalId: id, currentId: id };
      });

      const list = countries?.length ? countries : ViewService.dropDownTerritories;
      this.countryCodes = list.map((c) => ({ ...c, label: `${c.name} (${c.code})` }));
    } finally {
      this.isLoading = false;
    }
  }

  displayCustomerSource = (item?: { id: number; name: string; alternativeNames?: string[] }): string => {
    if (!item) {
      return '';
    }

    const alts =
      Array.isArray(item.alternativeNames) && item.alternativeNames.length
        ? ` (${item.alternativeNames.join(', ')})`
        : '';

    return `${item.name}${alts}`;
  };

  getInitialSourceId(manufacturerName: string): string | null {
    if (!manufacturerName) {
      return null;
    }

    const lower = manufacturerName.toLowerCase();
    const hit = this.customerProductDataSources.find(
      (ds) => ds.name?.toLowerCase() === lower || ds.alternativeNames?.some((a) => a.toLowerCase() === lower)
    );

    return hit ? hit.id : null;
  }

  async addNewSource() {
    var newDataSourceAddress = new Address();
    var newDataSourceImporterAddress = new Address();
    this.newAddedDatasource = {
      addressObj: newDataSourceAddress,
      importerAddress: newDataSourceImporterAddress
    } as ProductDataSource;
    this.popupVisible = true;
  }

  async onEditSaved($event) {
    this.customerProductDataSources = await this.dataSourcesService.getAll(this.loginService.currentCustomer.id);
    this.refreshPagedDataSources();
  }

  private refreshPagedDataSources() {
    this.customerProductDataSourcesPaged = new DataSource({
      store: new ArrayStore({ key: 'id', data: this.customerProductDataSources }),
      paginate: true,
      pageSize: 20
    });
  }

  changeDataSource(row: DataSourceMapping, newId: string | null) {
    row.currentId = newId;
  }

  apply() {
    let saveChangesDialog = custom({
      title: this.translate.instant('Makro Starten'),
      messageHtml: this.translate.instant(
        'Sollen die Mappings jetzt per Makro auf die entsprechenden Produkte übernommen werden?'
      ),
      buttons: [
        {
          text: this.translate.instant('Ja'),
          onClick: (e) => {
            return true;
          }
        },
        {
          text: this.translate.instant('Nein'),
          onClick: (e) => {
            return false;
          }
        }
      ]
    });

    saveChangesDialog.show().then(async (dialogResult) => {
      if (dialogResult) {
        await this.startApplyChangedMappingsMakro(this.catalogManufaturerNames);
      }
    });
  }

  async startApplyChangedMappingsMakro(mappings: DataSourceMapping[]) {
    await this.dataSourcesService.startApplyChangedMappingsMakro(
      mappings,
      this.loginService.currentCustomer.id,
      this.catalogService.catalog.id
    );
  }
}
